@if (rangeFilters?.length > 1) {
<div class="d-flex">
  @for (filter of rangeFilters; track filter.fieldId;) {
  <atx-radio
    [groupName]="radioGroupName"
    [inputId]="filter.displayName"
    [active]="currentFilter?.fieldId === filter.fieldId"
    (change)="filterChanged(filter.fieldId)"
    class="mr-4"
    >{{ filter | filterDisplayName }}
  </atx-radio>
  }
</div>
}

<atx-multi-range-slider
  class="mt-3"
  [ngClass]="{
    'mt-3': multiRangeSliderInputs,
    'mt-5': !multiRangeSliderInputs
  }"
  [min]="minRange$ | async"
  [max]="maxRange$ | async"
  [unit]="unit ? ' (' + unit + ')' : ''"
  [displayedMax]="displayedMax$ | async"
  (rangeChanged)="onRangeChanged($event)"
  [formControl]="rangeControl"
  [multiRangeSliderInputs]="multiRangeSliderInputs"
></atx-multi-range-slider>
